import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Key, Package } from 'lucide-react';

const AddToRentalDialog = ({
  open,
  onOpenChange,
  toolToAddToRental,
  rentalQuantity,
  setRentalQuantity,
  rentalStorageLocation,
  setRentalStorageLocation,
  onSubmit
}) => {
  if (!toolToAddToRental) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="font-heading">Ajouter à la Location</DialogTitle>
        </DialogHeader>
        <form onSubmit={onSubmit} className="space-y-4">
          <div className="p-4 bg-blue-50 dark:bg-blue-950/20 rounded-lg space-y-2 border border-blue-200">
            <div className="flex items-center gap-3">
              {toolToAddToRental.photo ? (
                <img
                  src={toolToAddToRental.photo}
                  alt={toolToAddToRental.name}
                  className="w-16 h-16 object-contain bg-muted rounded-lg"
                />
              ) : (
                <div className="w-16 h-16 bg-muted rounded-lg flex items-center justify-center">
                  <Package className="w-8 h-8 text-muted-foreground" />
                </div>
              )}
              <div>
                <p className="font-heading font-medium">{toolToAddToRental.name}</p>
                <p className="text-sm text-muted-foreground">{toolToAddToRental.type}</p>
              </div>
            </div>
            <p className="text-sm text-blue-700">
              Cet outil sera copié vers la section Location avec la quantité spécifiée.
            </p>
          </div>

          <div className="space-y-2">
            <Label htmlFor="rental_qty">Quantité à mettre en location</Label>
            <Input
              id="rental_qty"
              data-testid="rental-quantity-input"
              type="number"
              min="1"
              value={rentalQuantity}
              onChange={(e) => setRentalQuantity(parseInt(e.target.value) || 1)}
              className="rounded-lg"
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="rental_storage">Emplacement de stockage / retour</Label>
            <Input
              id="rental_storage"
              data-testid="rental-storage-input"
              value={rentalStorageLocation}
              onChange={(e) => setRentalStorageLocation(e.target.value)}
              placeholder="Ex: Atelier A, Armoire 3..."
              className="rounded-lg"
            />
            <p className="text-xs text-muted-foreground">
              Où l'équipement doit être rangé après utilisation
            </p>
          </div>

          <Button
            data-testid="confirm-add-to-rental-button"
            type="submit"
            className="w-full rounded-full"
          >
            <Key className="w-4 h-4 mr-2" />
            Ajouter à la Location
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default AddToRentalDialog;
